import { Component } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';

import { RESETVIEWLABELS, DETAILSVIEWLABELS } from '../_constants/constants';
import { CustomerService } from '../_services/customer.service';

export interface ResetDialogModel {
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'reset.dialog.component.html'
})

export class ResetDialogComponent extends DialogComponent<ResetDialogModel, string> implements ResetDialogModel {
  
    customerService: CustomerService;
    subValue: string;
    opcoValue: string;
    resetviewlabels = RESETVIEWLABELS;
    detailsviewlabels = DETAILSVIEWLABELS;

    constructor(private ds: DialogService) {
          super(ds);
    }

    agentResetRequest() {
        if(this.opcoValue=='ro'){
            this.customerService.roResetPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }else if(this.opcoValue=='vo'){
            this.customerService.voResetPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }
        else if(this.opcoValue=='al'){
            this.customerService.alResetPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }
        else if(this.opcoValue=='cz'){
            this.customerService.czResetPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }
        else if(this.opcoValue=='it'){
            this.customerService.itResetPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }
        else{
            this.customerService.resetPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }
       
        this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/reset/reset.dialog.component.ts